(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/best-bet-rows/assets/javascripts/best-bet-rows-grid.js') >= 0) return;  svs.modules.push('/components/pool-betting/best-bet-rows/assets/javascripts/best-bet-rows-grid.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useMemo = _React.useMemo,
  useRef = _React.useRef;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const DraggableContainer = svs.components.lbUi.DraggableContainer;
const selectMaskedOutcomes = svs.components.tipsen.store.reducers.resultModifier.selectors.selectMaskedOutcomes;
const _svs$components$poolB = svs.components.poolBetting.bestBetRows,
  useBestBetRows = _svs$components$poolB.hooks.useBestBetRows,
  SingleRowsPresentation = _svs$components$poolB.SingleRowsPresentation,
  SingleRow = _svs$components$poolB.SingleRow;
const getDefinitionByProduct = svs.components.tipsen.engine.utils.getDefinitionByProduct;
const getLogger = svs.core.log.getLogger;
const logger = getLogger('pool-betting:best-bet-rows');
const BestBetRowsGrid = _ref => {
  let wagerId = _ref.wagerId;
  const _maskedOutcomes = useSelector(state => selectMaskedOutcomes(state, wagerId));
  const maskedOutcomes = useMemo(() => _maskedOutcomes || [], [_maskedOutcomes]);
  const _useBestBetRows = useBestBetRows(),
    getBestBetRows = _useBestBetRows.getBestBetRows;
  const _getBestBetRows = getBestBetRows(),
    bestBetRows = _getBestBetRows.bestBetRows,
    resultOutcomes = _getBestBetRows.resultOutcomes,
    winDivisions = _getBestBetRows.winDivisions,
    productId = _getBestBetRows.productId;
  const eventTypeId = productId ? getDefinitionByProduct(productId).outcomes.eventTypeId : 0;
  const rowNumber = useRef(0);
  const bestBetRowComponents = useMemo(() => {
    rowNumber.current = 0;
    if (!bestBetRows.length) {
      return null;
    }
    const rows = [];
    const numMatches = resultOutcomes.length;
    for (const _ref2 of bestBetRows.entries()) {
      var _ref3 = _slicedToArray(_ref2, 2);
      const winDivisionKey = _ref3[0];
      const winDivisionValue = _ref3[1];
      if (!winDivisionValue.length) {
        continue;
      }
      rows.push(...winDivisionValue.map((row, index) => {
        const totalCorrects = resultOutcomes.length ? numMatches - winDivisionKey : '-';
        const winDiv = winDivisionKey + 1;
        const maskedResultOutcomes = resultOutcomes.map((drawResultOutcome, index) => {
          if (maskedOutcomes.includes(index)) {
            return [];
          }
          return drawResultOutcome;
        });
        if (winDivisionValue.length >= 60) {
          rowNumber.current = index + 1;
        } else {
          rowNumber.current = rowNumber.current + 1;
        }
        return React.createElement(SingleRow, {
          className: winDivisions.includes(winDiv) ? 'pb_best_bet_rows__row--is-in-pricegroup' : '',
          eventTypeId: eventTypeId
          ,
          key: row.join('') + index,
          productId: productId,
          resultOutcomes: maskedResultOutcomes,
          rowNumber: rowNumber.current,
          rowOutcomes: row,
          topic: totalCorrects
        });
      }));
    }
    return React.createElement(DraggableContainer, null, rows);
  }, [bestBetRows, resultOutcomes, winDivisions, eventTypeId, maskedOutcomes]);
  return React.createElement(SingleRowsPresentation, null, bestBetRowComponents);
};
setGlobal('svs.components.poolBetting.bestBetRows.BestBetRowsGrid', BestBetRowsGrid);

 })(window);